export var ManagementCompanyText = function ManagementCompanyText(_ref) {
  var entity = _ref.entity;
  return entity.name;
};